let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4bf6N")).then(() => parcelRequire('2yYee'));